import {
  formatDisplayDate,
  getRangeForPreset,
  toDateInputValue,
  WalletDatePreset,
  WALLET_DATE_PRESET_OPTIONS,
} from '../wallet/walletDateRange'

export type GiftCardDatePreset = WalletDatePreset

export type GiftCardFilterState = {
  preset: GiftCardDatePreset
  date_from: string
  date_to: string
  label: string
  all_time?: boolean
  category: string[]
}

export {
  formatDisplayDate,
  getRangeForPreset,
  toDateInputValue,
  WALLET_DATE_PRESET_OPTIONS as GIFT_CARD_DATE_PRESET_OPTIONS,
}

export const getDefaultGiftCardFilter = (): GiftCardFilterState => {
  const range = getRangeForPreset('today')
  return {...range, category: []}
}

export const buildGiftCardFilterSummary = (
  filter: GiftCardFilterState,
  search: string,
  totalRecords?: number
): string => {
  const rangeText = filter.all_time
    ? 'all dates'
    : filter.date_from === filter.date_to
      ? formatDisplayDate(filter.date_from)
      : `${formatDisplayDate(filter.date_from)} – ${formatDisplayDate(filter.date_to)}`

  const categoryText =
    filter.category.length > 0 ? `${filter.category.length} categor${filter.category.length === 1 ? 'y' : 'ies'}` : 'all categories'

  const parts = [filter.label, `(${rangeText})`, categoryText]
  if (search.trim()) parts.push(`search: "${search.trim()}"`)
  if (totalRecords !== undefined) {
    parts.push(`${totalRecords} redemption${totalRecords === 1 ? '' : 's'}`)
  }
  return parts.join(' · ')
}
